var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var uiMask = require('angular-ui-mask')

angular.module('OwInputZipCmp', [uiMask])
  .component('owInputZip', {
    template: require('./ow-input-zip.component.tpl.html'),
    controller: OwInputZipCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '<',
      onChanged: '&',
      tooltipLabel: '@',
      tooltipClass: '<'
    }
  })

OwInputZipCtrl.$inject = ['i18n']

function OwInputZipCtrl (i18n) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.id = 'field_' + vm.formField.id
    vm.zipCode = vm.value
    vm.uiOptions = {
      clearOnBlur: false,
      maskDefinitions: {
        '9': /\d/
      }
    }
    vm.mask = '999 99'
    vm.maskPlaceholder = '--- --'

    vm.onChange = onChange
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.errorMessages) {
      processErrors()
    }
  }

  function processErrors () {
    if (angular.isArray(vm.errorMessages)) {
      // reset current errors
      Object.keys(vm.form.field.$error).forEach(function (error) {
        vm.form.field.$setValidity(error, true)
      })
      // set external errors
      vm.errorMessages.forEach(function (error) {
        vm.form.field.$setValidity(error, false)
      })
    }
  }

  function onChange () {
    vm.onChanged({ value: vm.zipCode, formFieldId: vm.formField.id })
  }
}
